import { Http, URLSearchParams } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { AutenticacionService } from './autenticacion.service';
import { ValidatorService } from './tools/validator.service';
import { ErrorsService } from './tools/errors.service';

@Injectable()
export class PromotoresService {

  private service_url : string = '';
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService,
      private validatorService: ValidatorService,
      private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/promotores';
  }

  public getAll(filters : any) {
    let myParams = new URLSearchParams();

    if(filters.paginate){
      myParams.append('paginate', 'true');
    }

    if(filters.page){
      myParams.append('page', filters.page);
    }

    if(filters.search){
      myParams.append('search', filters.search);
    }

    if(filters.order){
      myParams.append('order', filters.order);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    return this.http.get(this.service_url , myoptions);
  }

  public get(id : number) {
    return this.http.get(this.service_url + '/' + id, this.authService.getAuthHeaders());
  }

  public delete(idPromotor : number) {
    return this.http.delete(this.service_url + '/' + idPromotor, this.authService.getAuthHeaders());
  }

  public save(promotor : object) {
    return this.http.post(this.service_url , promotor, this.authService.getAuthHeaders());
  }

  public update(promotor : object) {
    return this.http.put(this.service_url , promotor, this.authService.getAuthHeaders());
  }

  public validate(promotor: any){
    let error = [];

    if(!this.validatorService.required(promotor.nombre)){
        error["nombre"] = this.errorService.required;
    }

    if(!this.validatorService.required(promotor.clave)){
      error["clave"] = this.errorService.required;
    }

    if(!this.validatorService.required(promotor.direccion)){
      error["direccion"] = this.errorService.required;
    }

    if(!this.validatorService.required(promotor.telefono)){
      error["telefono"] = this.errorService.required;
    }

    if(!this.validatorService.required(promotor.email)){
      error["email"] = this.errorService.required;
    }

    if(!this.validatorService.required(promotor.fecha_nacimiento)){
      error["fecha_nacimiento"] = this.errorService.required;
    }

    if(!this.validatorService.required(promotor.comision)){
      error["comision"] = this.errorService.required;
    }
    
    return error;
  }

}


// WEBPACK FOOTER //
// ./src/app/services/promotores.service.ts